const API_KEY = import.meta.env.VITE_FOOTBALL_API_KEY;
const BASE_URL = 'https://v3.football.api-sports.io';

export interface Fixture {
  fixture: {
    id: number;
    date: string;
    timestamp: number;
    status: {
      long: string;
      short: string;
    };
  };
  league: {
    name: string;
    round: string;
  };
  teams: {
    home: {
      name: string;
      logo: string;
    };
    away: {
      name: string;
      logo: string;
    };
  };
  goals: {
    home: number | null;
    away: number | null;
  };
}

interface ApiResponse {
  response: Fixture[];
}

export async function getFixtures(type: 'next' | 'last', limit: number = 30): Promise<Fixture[]> {
  try {
    const response = await fetch(
      `${BASE_URL}/fixtures?venue=1184&${type}=${limit}&timezone=Europe/Oslo`,
      {
        headers: {
          'x-apisports-key': API_KEY,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: ApiResponse = await response.json();
    return data.response;
  } catch (error) {
    console.error('Football API Error:', error);
    throw error;
  }
}

export function formatMatchDate(dateString: string): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(date);
}

export function formatMatchTime(dateString: string): string {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('nb-NO', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}
